import { PhoneEmpty, type PhoneEmptyProps } from '@flobi/asset-library/ui';
import { usePhone } from '../ui/usePhone';

/**
 * The suite's empty state on a PHONE (Mohamad's pick E, 2026-10-26): a title in Artwork's own
 * face and violet, one line, and up to three ways to start. Laptops keep Artwork's own lines, so
 * every call site asks `usePhone()` first and draws this only on a phone.
 */
export function PhoneEmptyState(props: PhoneEmptyProps) {
  return <PhoneEmpty theme="artwork" {...props} />;
}

export { usePhone };
